import { render, staticRenderFns } from "./AccountHolderExpenseDistributionDetail.vue?vue&type=template&id=e0818bac&scoped=true"
import script from "./AccountHolderExpenseDistributionDetail.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseDistributionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0818bac",
  null
  
)

export default component.exports